import {useSortable} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Card, Col, Row } from 'react-bootstrap';

export const Methodology = ({methodology}) => {

    const {attributes, listeners, setNodeRef, transform, transition} = useSortable({id: methodology.id});

    const style = {
        transition,
        transform: CSS.Transform.toString(transform)
    }

    return(
        <Card {...attributes} {...listeners}  style={style} ref={setNodeRef} className="m-2 border-1 rounded dragable">
            <Card.Body>
                <Row className='align-items-center'>
                    <Col xs={12} className='d-flex align-items-center'>
                        <img src="/images/dragdrop.svg" alt="DragDrop" className='me-3'/>{methodology.name}
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}